<template>
    <b-modal v-if="!loading" id="category_form" ref="category_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            {{ !edit ? 'Add New Category' : 'Edit Category' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form @submit.prevent="submitCategory">
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? (delete errors.name) : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!('name' in errors)"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('category_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitCategory">Submit</state-button>

            <state-button v-else variant="primary" :click="updateCategory">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "CategoryFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit'
    ],

    data() {
        return{
            loading: true,
        }
    },

    computed: {
        ...mapGetters({
            form: 'getInspectionCategoryForm',
            errors: 'getInspectionCategoryErrors',
        })
    },

    mounted() {
        this.loading = false;
    },

    methods: {
        resetForm() {
            this.$store.commit('setInspectionCategoryForm');
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitCategory() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitInspectionCategory', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new category!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('category_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateCategory() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateInspectionCategory', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the category!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('category_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
